import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";

const PageProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Start with a small jump
    setProgress(10);
    
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev;
        // Slow down as it gets closer to 90%
        const remaining = 90 - prev;
        const increment = Math.random() * (remaining / 10);
        return prev + increment;
      });
    }, 300);

    return () => {
      clearInterval(interval);
      setProgress(100);
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "3px",
        zIndex: 10000,
        backgroundColor: "transparent",
      }}
    >
      <div
        style={{
          width: `${progress}%`,
          height: "100%",
          backgroundColor: "#0f203a",
          boxShadow: "0 0 10px #0f203a, 0 0 5px #0f203a",
          transition: "width 0.4s ease-in-out",
        }}
      />
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "15px",
        }}
      >
        <ClipLoader
          sizeUnit={"px"}
          size={50}
          color={"#0f203a"}
          loading={true}
        />
      </div>
    </div>
  );
};

export default PageProgressBar;
